import { render } from "./TreeSelect.vue?vue&type=template&id=2a5c9130&scoped=true"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"

import "./TreeSelect.vue?vue&type=style&index=0&id=2a5c9130&lang=scss&scoped=true"

import exportComponent from "/builds/dock/research/autocbm/autocbm-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5c9130"]])

export default __exports__